import DefaultLayout from "@/components/layouts/DefaultLayout";
import BlogPost from "@/components/views/Blog/BlogPost";
import {
  getBlogPostBySlug,
  getSlugsForContentType,
} from "@/services/DefaultService";
import { ContentTypes } from "@/types/ContentTypes";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import NotFoundPage from "../404";

interface Props {
  post: any;
}

const Index: NextPage<Props> = ({ post }) => {
  if (!post) {
    return <NotFoundPage />;
  }

  return (
    <DefaultLayout seo={post.attributes.seo}>
      <BlogPost post={post} />
    </DefaultLayout>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  let paths = [];
  try {
    const slugs = await getSlugsForContentType(ContentTypes.BLOG_POSTS);
    paths = slugs.map((slug: string) => ({
      params: { slug },
    }));
  } catch (err) {
  } finally {
    return {
      paths,
      fallback: "blocking",
    };
  }
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const slug = context.params?.slug as string;
    const data = await getBlogPostBySlug({ slug });

    return {
      props: {
        post: data.data,
      },
    };
  } catch (err) {
    return {
      props: {
        post: null,
      },
    };
  }
};

export default Index;
